import { SignatureProps } from "../App";
import ImageLogo from "./ImageLogo";

const Signature = ({
  fullName,
  position,
  phone,
  banners,
  selectedBannerType,
}: SignatureProps) => {
  return (
    <table
      cellPadding={0}
      cellSpacing={0}
      className={"signature"}
      style={{
        fontFamily: "Arial, Helvetica, sans-serif",
        width: "100%",
        maxWidth: 600,
      }}
    >
      <tbody>
        <tr>
          <td
            style={{
              backgroundImage: "linear-gradient(0deg, #0960F6 0%, #8839F5 50%, #FF290C 100%)",
              padding: 2,
            }}
          ></td>
          <td>
            <table cellPadding={0} cellSpacing={0}>
              <tbody>
                <tr>
                  <td
                    style={{
                      fontSize: 14,
                      fontWeight: 800,
                      color: "#FF290C",
                      paddingTop: 2,
                      paddingLeft: 24,
                    }}
                  >
                    {fullName}
                  </td>
                </tr>
              </tbody>
            </table>
            <table cellPadding={0} cellSpacing={0}>
              <tbody>
                <tr>
                  <td
                    colSpan={3}
                    style={{
                      fontSize: 14,
                      fontWeight: 400,
                      color: "#011840",
                      paddingLeft: 24,
                    }}
                  >
                    {position}
                  </td>
                </tr>
              </tbody>
            </table>
            <table cellPadding={24} cellSpacing={0}>
              <tbody>
                <tr>
                  <td
                    colSpan={3}
                    style={{
                      fontSize: 14,
                      fontWeight: 400,
                      color: "#011840",
                      paddingLeft: 24,
                    }}
                  >
                    {phone ? (
                      <>
                        <strong>M. </strong>
                        {phone}
                      </>
                    ) : null}
                  </td>
                </tr>
              </tbody>
            </table>
            <table cellPadding={0} cellSpacing={0}>
              <tbody>
                <tr>
                  <td colSpan={3} style={{ paddingLeft: 24 }}>
                    <a
                      href={"https://www.roller.software/"}
                      style={{ display: "flex" }}
                    >
                      <img
                        width={146}
                        src="https://signature.rollersoftware.com/email-logo.png"
                        alt="ROLLER - All-in-on Venue Management software"
                        title="Roller"
                      />
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
            <table cellPadding={0} cellSpacing={0}>
              <tbody>
                <tr>
                  <td colSpan={3} style={{ paddingLeft: 24 }}>
                    <div
                      style={{
                        display: "flex",
                        fontSize: 12,
                        color: "#011840",
                        letterSpacing: -0.16,
                        fontWeight: 400,
                        paddingTop: 8,
                      }}
                    >
                      <a
                        href={"https://www.roller.software/"}
                        title="ROLLER - All-in-on Venue Management software"
                        style={{ color: "#011840" }}
                      >
                        Website
                      </a>
                      <span style={{ marginLeft: 3, marginRight: 3 }}>|</span>
                      <a
                        href={"https://www.linkedin.com/company/roller/"}
                        title="ROLLER - LinkedIn"
                        style={{ color: "#011840" }}
                      >
                        LinkedIn
                      </a>
                      <span style={{ marginLeft: 3, marginRight: 3 }}>|</span>
                      <a
                        href={
                          "https://www.roller.software/the-guest-experience-show/"
                        }
                        title="ROLLER - The Guest Experience"
                        style={{ color: "#011840" }}
                      >
                        Podcast
                      </a>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <table cellPadding={0} cellSpacing={0}>
              <tbody>
                <tr>
                  <td colSpan={3} style={{ paddingTop: 24 }}>
                    <a
                      href={
                        selectedBannerType &&
                        banners &&
                        banners[selectedBannerType]
                          ? banners[selectedBannerType].linkUrl
                          : ""
                      }
                      style={{ display: "flex" }}
                      title="ROLLER - All-in-on Venue Management software"
                    >
                      <img
                        src={
                          selectedBannerType &&
                          banners &&
                          banners[selectedBannerType]
                            ? banners[selectedBannerType].imageUrl
                            : ""
                        }
                        width={596}
                        alt="ROLLER - All-in-on Venue Management software"
                        style={{
                          width: "100%",
                          maxWidth: 596,
                          height: "auto",
                          display: "block",
                        }}
                      />
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
            <table cellPadding={0} cellSpacing={0}>
              <tbody>
                <tr>
                  <td
                    colSpan={3}
                    style={{
                      fontSize: 12,
                      fontWeight: 400,
                      color: "#011840",
                      paddingLeft: 24,
                      paddingTop: 24,
                      paddingBottom: 18,
                    }}
                  >
                    Check out our consistently high industry ratings:
                  </td>
                </tr>
              </tbody>
            </table>
            <table cellPadding={0} cellSpacing={0} width="100%">
              <tbody>
                <tr>
                  <td colSpan={3} style={{ paddingLeft: 24 }}>
                    <div className="signature-badges">
                      <a
                        href={
                          "https://www.softwareadvice.com/retail/web-based-point-of-sale-software-comparison/#frontrunners"
                        }
                        title="ROLLER - Sofware Advice"
                        className="signature-badge-link"
                      >
                        <ImageLogo
                          src="https://signature.rollersoftware.com/software-advice.png"
                          alt="ROLLER - Sofware Advice"
                          width={64}
                          fallbackSrc="/software-advice.png"
                          title="ROLLER - Sofware Advice"
                          className="signature-badge-img"
                        />
                      </a>
                      <a
                        href={
                          "https://www.g2.com/products/roller-software/reviews?utm_source=rewards-badge"
                        }
                        title="ROLLER - G2"
                        className="signature-badge-link"
                      >
                        <ImageLogo
                          width={48}
                          src="/users-love-us.png"
                          fallbackSrc="G2@2x.png"
                          alt="ROLLER - G2"
                          title="ROLLER - G2"
                          className="signature-badge-img"
                        />
                      </a>
                      <a
                        href={
                          "https://www.capterra.com/point-of-sale-software/shortlist"
                        }
                        title="ROLLER - Capterra"
                        className="signature-badge-link"
                      >
                        <ImageLogo
                          src="https://signature.rollersoftware.com/capterra.png"
                          alt="ROLLER - Capterra"
                          width={68}
                          fallbackSrc="capterra.png"
                          title="ROLLER - Capterra"
                          className="signature-badge-img"
                        />
                      </a>
                      <a
                        href={
                          "https://sourceforge.net/software/product/ROLLER/"
                        }
                        title="ROLLER - Sourceforge User Reviews"
                        className="signature-badge-link"
                      >
                        <ImageLogo
                          src="/leader-spring-white-sourceforge.svg"
                          alt="ROLLER - Sourceforge User Reviews"
                          width={52}
                          fallbackSrc="/leader-spring-white-sourceforge.svg"
                          title="ROLLER - Sourceforge User Reviews"
                          className="signature-badge-img"
                        />
                      </a>
                      <a
                        href={
                          "https://www.getapp.com/customer-management-software/point-of-sale/category-leaders"
                        }
                        title="ROLLER - GetApp"
                        className="signature-badge-link"
                      >
                        <ImageLogo
                          width={64}
                          src="/getapp.png"
                          fallbackSrc="GA-Badge.png"
                          alt="ROLLER - GetApp"
                          title="ROLLER - GetApp"
                          className="signature-badge-img"
                        />
                      </a>
                      <a
                        href={"https://slashdot.org/software/p/ROLLER/"}
                        title="ROLLER - Slashdot User Reviews"
                        className="signature-badge-link"
                      >
                        <ImageLogo
                          src="/leader-spring-white-slashdot.svg"
                          alt="ROLLER - Slashdot User Reviews"
                          title="ROLLER - Slashdot User Reviews"
                          width={46}
                          fallbackSrc="/leader-spring-white-slashdot.svg"
                        />
                      </a>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>
  );
};

export default Signature;
